import { FC, ReactNode } from "react";
import cx from "classnames";
import { ExclamationCircle, Typography } from "@earned/core";

interface InputErrorProps {
  value?: ReactNode;
}

const InputError: FC<InputErrorProps> = ({ value }) => {
  return (
    <div className="mt-2 flex min-h-4 items-start gap-1">
      {value && <ExclamationCircle className="mt-0.5 h-4 w-4 flex-shrink-0" />}
      <Typography variant="body" color="danger" component="h6">
        <p
          className={cx(
            "whitespace-pre-line text-input-helper",
            value ? "" : "hidden"
          )}
        >
          {value}
        </p>
      </Typography>
    </div>
  );
};

export default InputError;
